import React from 'react';
import { Link } from 'react-router-dom';
import BaseCard, { BaseCardProps } from '../BaseCard';
import './styles.css';

interface LinkCardProps extends Omit<BaseCardProps, 'variant'> {
  to: string;
}

const LinkCard: React.FC<LinkCardProps> = ({
  to,
  className = '',
  children,
  ...rest
}) => {
  return (
    <Link to={to} className={`card-link ${className}`}>
      <BaseCard variant="list" {...rest}>
        {children}
      </BaseCard>
    </Link>
  );
};

export default LinkCard; 